import { render, staticRenderFns } from "./JDictSelectTag.vue?vue&type=template&id=33375052&scoped=true&"
import script from "./JDictSelectTag.vue?vue&type=script&lang=js&"
export * from "./JDictSelectTag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33375052",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('33375052')) {
      api.createRecord('33375052', component.options)
    } else {
      api.reload('33375052', component.options)
    }
    module.hot.accept("./JDictSelectTag.vue?vue&type=template&id=33375052&scoped=true&", function () {
      api.rerender('33375052', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dict/JDictSelectTag.vue"
export default component.exports